import { apiRequest } from './api'

export const dashboardService = {
  /**
   * Get records created today count based on user role and permissions
   * @returns {Promise} Promise resolving to records today data
   */
  getRecordsToday: async () => {
    const response = await apiRequest.get('/dashboard/records-today')
    return response.data
  },

  /**
   * Get dashboard statistics summary
   * @returns {Promise} Promise resolving to dashboard statistics
   */
  getDashboardStats: async () => {
    const response = await apiRequest.get('/dashboard/stats')
    return response.data
  },

  /**
   * Get recent activities for dashboard
   * @param {number} limit - Number of activities to fetch
   * @returns {Promise} Promise resolving to recent activities
   */
  getRecentActivities: async (limit = 5) => {
    const response = await apiRequest.get(`/dashboard/recent-activities?limit=${limit}`)
    return response.data
  }
}
